import { Link } from "react-router-dom"


export const SelectInvoice = ({ flo, handleRemoveInvoice, handleChangeSelectInvoice, handleOpenNewInvoice, invoicesList }) => {
    return (
        <>
            {flo?.info_invoice ?
                <div className="flex flex-col items-start">
                    <Link
                        className="p-mini-link"
                        to={`/facturas/${flo?.info_invoice?.id}`}
                        target='_blank'
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'green' }}
                    >
                        <div className="text-start">
                            <i class="bi bi-check-circle-fill"></i>
                            <span className='ms-1'>Facturado</span>
                        </div>
                        <div className="text-start"
                            style={{ textTransform: 'uppercase', fontSize: '10px', color: 'gray' }}>
                            Nro. {flo?.info_invoice?.numero}
                        </div>
                    </Link>
                    <Link
                        to=""
                        className="text-xs capitalize mt-2 hover:text-gray-500 hover:underline"
                        onClick={() => handleRemoveInvoice("ingreso", flo)}
                    >
                        <i className="bi bi-x"></i>
                        Quitar factura
                    </Link>
                </div>
                :
                <div className='d-flex flex-column justify-content-start align-items-start'>
                    <Link
                        to=""
                        onClick={() => handleOpenNewInvoice(flo, 'ingreso')}
                        className="p-mini-link"
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'green' }}
                    >
                        + Crear factura
                    </Link>

                    {invoicesList.length > 0 ?
                        <select
                            className='mt-1'
                            style={{ cursor: 'pointer', width: '180px', textTransform: 'uppercase', fontSize: '11px' }}
                            onChange={(e) => handleChangeSelectInvoice(e, flo)}
                        >
                            <option value=''>--seleccionar existente--</option>
                            {invoicesList.map(inv => (
                                <option
                                    key={inv.id}
                                    value={inv.id}
                                    className='p-2'
                                >Nro. {inv.numero}{' | '}{inv.referencia}
                                </option>
                            ))}
                        </select> : ''
                    }

                </div>
            }
        </>
    )
}